var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49978 15L9.49978 3.83L14.3798 8.71C14.7698 9.1 15.4098 9.1 15.7998 8.71C16.1898 8.32 16.1898 7.69 15.7998 7.3L9.20978 0.71C8.81978 0.319999 8.18978 0.319999 7.79978 0.71L1.20978 7.3C0.819783 7.69 0.819783 8.32 1.20978 8.71C1.59978 9.1 2.22979 9.1 2.61979 8.71L7.49978 3.83L7.49979 15C7.49979 15.55 7.94979 16 8.49978 16C9.04979 16 9.49978 15.55 9.49978 15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCollapse);
export default __webpack_public_path__ + "static/media/arrow-collapse.81b7765d.svg";
export { ForwardRef as ReactComponent };